import { fetcherModeAtom, useCurrentUser } from "@keepeek/commons";
import { PlayerViewerProps } from "@keepeek/refront-components";
import { selectorFamily } from "recoil";

import { playerFetcherSelector } from "../fetcher/selectors/viewer";
import { convertToPlayerProps } from "./utils";

export const playerViewerSelector = selectorFamily<PlayerViewerProps | null, number | null>({
  key: "PlayerViewerSelector",
  get:
    (mediaId) =>
    async ({ get }) => {
      if (!mediaId) {
        return null;
      }
      const { currentUser } = useCurrentUser();
      const { getPlayerConfiguration } = get(playerFetcherSelector(get(fetcherModeAtom)));
      const getPlayerConfigurationQuery = await getPlayerConfiguration(mediaId);
      if (!getPlayerConfigurationQuery) {
        return null;
      }
      const { data: mediaPlayer } = getPlayerConfigurationQuery;

      return { ...convertToPlayerProps(mediaPlayer, currentUser ? currentUser.id : undefined) };
    },
});
